import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';

export default class NewReportButton extends Component {
    render() {
        const id = this.props.id;
        return (
            <NavLink
                to={`/customer/${id}/reports/new`}
                className={'btn btn-primary mb-3'}
            >
                Neuen Bericht
            </NavLink>

        )
    }
}
